const GCLOUD_PROJECT_PATTERN = /^[A-Za-z0-9-]+$/;

export const gcloudProjectValidator = async (id: string, _field: string) => {
  if (!id.match(GCLOUD_PROJECT_PATTERN))
    return "Google Cloud project identifiers must consist of alphanumeric characters and hyphens only";
};
